<template>
    <div>
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>

        <!-- add title, refresh buttons, etc.  -->

        <FormulateForm
            :schema="formSchema"
            :data="formData"
            @submit="handleSubmit"
        ></FormulateForm>
        <!-- make sure all components you're rendering with this are known to Vue! -->

    </div>
</template>

<script>
import { errorHandling } from '../../js/custom-vue-mixins';
import { suppliosApi } from '../../js/api-service';

export default {
    name: 'SingleAnalyticsView',
    components: {
    },
    mixins: [
        errorHandling,
    ],
    props: {
        viewId: {
            type: String,
            required: false,  // CHANGE LATER
        },
    },
    data() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            formSchema: [],
            formData: {},
        }
    },
    computed: {
    },
    mounted() {
        this.getView();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        async getView() {
            this.loading = true;
            let resp;
            try {
                resp = await suppliosApi.internal.testAnalyticsViewGet();
            } catch (error) {
                this.apiErrorHandler(error);
            }
            if (resp?.data) {
                this.handleApiData(resp.data);
            }
            this.loading = false;
        },
        async handleSubmit(submitData) {
            console.log('submitData', submitData);
            this.loading = true;
            // TODO - give everything a key, maybe on backend, at least with a timestamp, so it forces refresh when we call this
            // but for now we'll just blank everything?
            this.formSchema = [];
            this.formData = {};
            let resp;
            try {
                resp = await suppliosApi.internal.testAnalyticsViewPost(submitData);
            } catch (error) {
                this.apiErrorHandler(error);
            }
            if (resp?.data) {
                this.handleApiData(resp.data);
            }
            this.loading = false;
        },
        handleApiData(respData) {
            // prep / modify / add to the schema  - like adding a submit button
            console.log('respData', respData);
            const rawSchema = respData.schema;  
            let finalSchema;
            if (Array.isArray(rawSchema) && rawSchema.length) {
                // add a submit button
                // no need - did it on backend - const submitButton = {type: "submit"};
                finalSchema = [...rawSchema];
            } else {
                finalSchema = [...rawSchema];
            }
            this.formSchema = finalSchema;  // transform the schema at all??? add submit button at least?
            this.formData = respData.data;
            //console.log('Just set data from API', this.formData);
        },
    },
}
</script>

<style>

</style>